var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#4CA88D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9591 15.9716H23.4859V14.3438C23.4859 13.2271 22.5774 12.2996 21.4417 12.2996L16.672 12.2998V10.6152C17.3722 10.3502 17.8644 9.66882 17.8644 8.87386C17.8644 7.83281 17.0316 7 15.9906 7C14.9496 7 14.1167 7.83285 14.1167 8.87386C14.1167 9.66882 14.6088 10.3313 15.3092 10.6152V12.2998H10.5205C9.4038 12.2998 8.47632 13.2082 8.47632 14.3439V15.9717L8.02202 15.9716C7.45416 15.9716 7 16.4259 7 16.9936V19.3974C7 19.9653 7.4543 20.4195 8.02202 20.4195H8.49521V22.1987C8.49521 23.3154 9.4037 24.2429 10.5394 24.2429H21.4606C22.5773 24.2429 23.5048 23.3344 23.5048 22.1987V20.4195H23.978C24.5458 20.4195 25 19.9652 25 19.3974V16.9937C24.9811 16.4448 24.5268 15.9716 23.9591 15.9716ZM11.5994 16.7476C11.5994 15.8959 12.2808 15.2145 13.1325 15.2145C13.9842 15.2145 14.6656 15.8959 14.6656 16.7476C14.6656 17.5993 13.9842 18.2807 13.1325 18.2807C12.2808 18.2807 11.5994 17.5993 11.5994 16.7476ZM17.4858 21.5552H14.4954C14.1169 21.5552 13.814 21.2524 13.814 20.8739C13.814 20.4953 14.1169 20.1925 14.4954 20.1925H17.4671C17.8456 20.1925 18.1485 20.4953 18.1485 20.8739C18.1672 21.2524 17.8455 21.5552 17.4858 21.5552ZM18.8486 18.2807C17.9969 18.2807 17.3155 17.5993 17.3155 16.7476C17.3155 15.8959 17.9969 15.2145 18.8486 15.2145C19.7003 15.2145 20.3817 15.8959 20.3817 16.7476C20.3819 17.5993 19.7005 18.2807 18.8486 18.2807Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappBot);
export default __webpack_public_path__ + "static/media/whatsappBot.be1ea895.svg";
export { ForwardRef as ReactComponent };